import i18next from "i18next"

export const BIKE_ID_MIN_LENGTH = 7
export const BIKE_ID_MAX_LENGTH = 14

// BIKE STATUS
export const BIKE_STORE = null
export const BIKE_SOLD = 1
export const BIKE_STOLEN = 2
export const BIKE_NOT_AVAILABLE = 3 // Destroy
export const BIKE_IN_SALE = 5
export const BIKE_BACK_STORE = 6

// BIKE EDITING MODE
export const REGISTER_MODE = "register"
export const UPDATE_MODE = "update"

/**
 * 📣 translation data will change only if browser is refresh
 */
export const UNKNOWN_STATUS_LABEL = i18next.t("status.unknown", { ns: "bike" })
export const IN_STORE_STATUS_LABEL = i18next.t("status.in_store", { ns: "bike" })
export const SOLD_STATUS_LABEL = i18next.t("status.sold", { ns: "bike" })
export const NOT_AVAILABLE_STATUS_LABEL = i18next.t("status.not_available", { ns: "bike" })

export const NOT_AVAILABLE_STATUS_DESCRIPTION = i18next.t("status.not_available_description", { ns: "bike" })
export const IN_SALE_BY_OWNER_STATUS_DESCRIPTION = i18next.t("status.in_sale_by_owner_description", { ns: "bike" })

export const bikeStatusList = [
    { id: "unknown", value: -1, label: UNKNOWN_STATUS_LABEL, description: null },
    { id: "in_store", value: BIKE_STORE, label: IN_STORE_STATUS_LABEL, description: null },

    { id: "sold", value: BIKE_SOLD, label: SOLD_STATUS_LABEL, description: null },
    { id: "stolen", value: BIKE_STOLEN, label: NOT_AVAILABLE_STATUS_LABEL, description: NOT_AVAILABLE_STATUS_DESCRIPTION },
    { id: "not_available", value: BIKE_NOT_AVAILABLE, label: NOT_AVAILABLE_STATUS_LABEL, description: NOT_AVAILABLE_STATUS_DESCRIPTION },
    { id: "not_available_2", value: 4, label: NOT_AVAILABLE_STATUS_LABEL, description: NOT_AVAILABLE_STATUS_DESCRIPTION },
    { id: "not_available_3", value: BIKE_IN_SALE, label: NOT_AVAILABLE_STATUS_LABEL, description: IN_SALE_BY_OWNER_STATUS_DESCRIPTION },
    { id: "back_in_store", value: BIKE_BACK_STORE, label: IN_STORE_STATUS_LABEL, description: null }
]

/**
 * 📣 On lang is changing, tranlation data must be update
 */
export const getBikeStatusLabelByValue = (value: number) => {
    const _UNKNOWN_STATUS_LABEL = i18next.t("status.unknown", { ns: "bike" })
    const _IN_STORE_STATUS_LABEL = i18next.t("status.in_store", { ns: "bike" })
    const _SOLD_STATUS_LABEL = i18next.t("status.sold", { ns: "bike" })
    const _NOT_AVAILABLE_STATUS_LABEL = i18next.t("status.not_available", { ns: "bike" })
    const _NOT_AVAILABLE_STATUS_DESCRIPTION = i18next.t("status.not_available_description", { ns: "bike" })
    const _IN_SALE_BY_OWNER_STATUS_DESCRIPTION = i18next.t("status.in_sale_by_owner_description", { ns: "bike" })

    const _bikeStatusList = [
        { id: "unknown", value: -1, label: _UNKNOWN_STATUS_LABEL, description: null },
        { id: "in_store", value: BIKE_STORE, label: _IN_STORE_STATUS_LABEL, description: null },

        { id: "sold", value: BIKE_SOLD, label: _SOLD_STATUS_LABEL, description: null },
        { id: "stolen", value: BIKE_STOLEN, label: _NOT_AVAILABLE_STATUS_LABEL, description: _NOT_AVAILABLE_STATUS_DESCRIPTION },
        { id: "not_available", value: BIKE_NOT_AVAILABLE, label: _NOT_AVAILABLE_STATUS_LABEL, description: _NOT_AVAILABLE_STATUS_DESCRIPTION },
        { id: "not_available_2", value: 4, label: _NOT_AVAILABLE_STATUS_LABEL, description: _NOT_AVAILABLE_STATUS_DESCRIPTION },
        { id: "not_available_3", value: BIKE_IN_SALE, label: _NOT_AVAILABLE_STATUS_LABEL, description: _IN_SALE_BY_OWNER_STATUS_DESCRIPTION },
        { id: "back_in_store", value: BIKE_BACK_STORE, label: _IN_STORE_STATUS_LABEL, description: null }
    ]

    const status = _bikeStatusList.find(bikeStatus => bikeStatus.value === value)
    return status ? status.label : value
}
